import PropTypes from "prop-types";
import { Box, Typography } from '@mui/material';
import {
    format,
    addDays,
    startOfWeek,
    setHours,
    setMinutes,
    isSameDay,
    isSameHour,
} from 'date-fns';

import { ru } from 'date-fns/locale';

const HOURS = Array.from({ length: 12 }, (_, i) => i + 8); // 8:00–20:00
const CELL_HEIGHT = 60; // px (высота одного часа)

WeekCalendar.propTypes = {
    events: PropTypes.array,
    onEventClick: PropTypes.func,
}

export default function WeekCalendar(props) {
    const start = startOfWeek(new Date(), { weekStartsOn: 1 }); // понедельник

    function isSameDayUTC(d1, d2) {
        return (
            d1.getUTCFullYear() === d2.getUTCFullYear() &&
            d1.getUTCMonth() === d2.getUTCMonth() &&
            d1.getUTCDate() === d2.getUTCDate()
        );
    }

    return (
        <Box sx={{ display: 'grid', gridTemplateColumns: '60px repeat(7, 1fr)', height: '100%' }}>
            {/* Заголовки дней */}
            <Box />
            {[...Array(7)].map((_, i) => (
                <Box
                    key={i}
                    sx={{
                        border: '1px solid #ccc',
                        p: 1,
                        textAlign: 'center',
                        backgroundColor: '#f9f9f9',
                    }}
                >
                    <Typography variant="body2">
                        {format(addDays(start, i), 'EEE dd.MM', { locale: ru })}
                    </Typography>
                </Box>
            ))}

            {/* Сетка */}
            {HOURS.map((hour) => (
                <>
                    {/* Колонка часов */}
                    <Box
                        key={`label-${hour}`}
                        sx={{
                            border: '0px solid #eee',
                            p: 1,
                            height: `${CELL_HEIGHT}px`,
                            boxSizing: 'border-box',
                        }}
                    >
                        <Typography variant="caption">{hour}:00</Typography>
                    </Box>

                    {/* Ячейки по дням */}
                    {[...Array(7)].map((_, i) => {
                        const dayDate = addDays(start, i+1);
                        const cellTime = setHours(setMinutes(dayDate, 0), hour);

                        return (
                            <Box
                                key={`${hour}-${i}`}
                                sx={{
                                    border: '1px solid #eee',
                                    height: `${CELL_HEIGHT}px`,
                                    position: 'relative',
                                    '&:hover': { cursor: 'pointer' },
                                }}
                                onClick={() => console.log('Click:', cellTime)}
                            >
                                {/* События */}
                                {props.events
                                    .filter((ev) => {
                                        const evStart = new Date(ev.start);
                                        return isSameDayUTC(evStart, dayDate) && evStart.getHours() === hour;
                                    })
                                    .map((ev, idx) => {
                                        const evStart = new Date(ev.start);
                                        const evEnd = new Date(ev.end);
                                        const minutes = evStart.getMinutes();
                                        const duration = (evEnd - evStart) / 60000;
                                        const topOffset = (minutes / 60) * CELL_HEIGHT;
                                        const height = Math.max((duration / 60) * CELL_HEIGHT, 20);

                                        return (
                                            <Box
                                                onClick={(event) => { props.onEventClick(ev); }}
                                                key={idx}
                                                sx={{
                                                    position: 'absolute',
                                                    top: `${topOffset}px`,
                                                    left: 2,
                                                    right: 2,
                                                    height: `${height}px`,
                                                    backgroundColor: '#1976d2',
                                                    color: 'white',
                                                    p: '2px 4px',
                                                    borderRadius: 1,
                                                    fontSize: '0.75rem',
                                                    overflow: 'hidden',
                                                    whiteSpace: 'nowrap',
                                                    textOverflow: 'ellipsis',
                                                    boxShadow: 1,
                                                    zIndex: 10
                                                }}
                                            >
                                                {ev.title}
                                                <br />
                                                {ev.groups.join(', ')}
                                                <br />
                                                {ev.lessonType}
                                            </Box>
                                        );
                                    })}
                            </Box>
                        );
                    })}
                </>
            ))}
        </Box>
    );
}